import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import 'virtual:svg-icons-register';
import './assets/style.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import App from './App.vue';
import { createPinia } from 'pinia';
import router from './router';
import i18n from './i18n/index.ts';
import { loadExternalResources } from '@/utils/loadExternalResources';
import { installDvhFallback } from '@/utils/viewportUnitFallback';

installDvhFallback();

const pinia = createPinia();
const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(pinia);
app.use(ElementPlus);
app.use(router);
app.use(i18n);

loadExternalResources().then(() => {
  app.mount('#app');
});
